import { getAuth } from "firebase/auth";
import moment from "moment";

import store from "../../redux/store";
import { setUserToken } from "../../redux/slices/userSlice";
import { server } from "../../config/ConfigFirebase";
import { debugLog } from "../../functions";

const handleContract = async (token, body) => {
  const response = await fetch("https://" + server + ".cloudfunctions.net/handleContract", {
    method: "post",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  if (response.status === 401) {
    const auth = getAuth();
    const token = await auth.currentUser.getIdToken();
    store.dispatch(setUserToken(token));
  }

  return response;
};

export const addContract = async(contract, user) => {
  try {
    const userBody = { action: "CREATE_CONTRACT", data: contract };
    let response = await handleContract(user.token, userBody);
    response = await response.json();
    if (response.result) {
      return response.body;
    } else {
      return null;
    }
  } catch (error) {
    debugLog(error);
    return null;
  }
};

export const getContract = async(contractCode, user) => {
  try {
    const userBody = { action: "GET_CONTRACT", contractCode, userId: user.userId };
    let response = await handleContract(user.token, userBody);
    response = await response.json();
    if (response.result && response.body) {
      const contract = {
        ...response.body,
        approvedAt: moment(new Date(response.body.approvedAt)),
        finishedAt: moment(new Date(response.body.finishedAt)),
        startedAt: moment(new Date(response.body.startedAt)),
        news: response.body.news?.map(n => ({
          ...n,
          startedAt: n.startedAt ? moment(new Date(n.startedAt)) : null,
          finishedAt: n.finishedAt ? moment(new Date(n.finishedAt)) : null,
        }))
      }
      if (contract.payments) {
        Object.keys(contract.payments).forEach((key) => {
          if (contract.payments[key].payAt) {
            contract.payments[key].payAt = moment(new Date(contract.payments[key].payAt));
          }
        });
      }
      return contract;
    } else {
      return null;
    }
  } catch (error) {
    debugLog(error);
    return null;
  }
};

export const updateContract = async(contractCode, data, user) => {
  try {
    const userBody = { action: "UPDATE_CONTRACT", contractCode, data };
    let response = await handleContract(user.token, userBody);
    response = await response.json();
    if (response.result) {
      return response.body;
    } else {
      return null;
    }
  } catch (error) {
    debugLog(error);
    return null;
  }
};

// Variante de updateContract que conserva la respuesta de error del backend.
// La usan el envío y la aprobación del acta, que deben mostrar el motivo cuando
// el servidor rechaza por fecha de corte (409 CUTOFF_CLOSED).
export const updateContractResult = async (contractCode, data, user) => {
  try {
    const userBody = { action: "UPDATE_CONTRACT", contractCode, data };
    let response = await handleContract(user.token, userBody);
    response = await response.json();
    if (response.result) return { ok: true, body: response.body };
    return { ok: false, error: response.error || null, message: response.message || null };
  } catch (error) {
    debugLog(error);
    return { ok: false, error: "NETWORK", message: null };
  }
};

export const getContracts = async(user, userType, year, noSelect) => {
  try {
    let userBody

    if (!userType) {
      userBody = { action: "GET_CONTRACTS" };
    } else {
      userBody = { action: "GET_CONTRACTS", userType, userId: user.userId };
    }

    if (year) userBody.year = year;
    if (noSelect) userBody.noSelect = noSelect;

    // El alcance por naturaleza (allowedNatures) y por tipo de contrato
    // (contractTypes) lo resuelve el backend desde el perfil del usuario.

    let response = await handleContract(user.token, userBody);
    response = await response.json();
    if (response.result) {
      return response.body;
    } else {
      return null;
    }
  } catch (error) {
    debugLog(error);
    return null;
  }
};

export const HandlePdfChargeAccount = async(dataSource, user) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CONTAINER}/Document/HandlePdfChargeAccount`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
        body: JSON.stringify(dataSource),
      }
    );

    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/pdf")) {
      const blob = await response.blob();
      return { blob };
    }

    const responseJSON = await response.json();
    return responseJSON;
  } catch (error) {
    debugLog(error);
    return null;
  }
};

export const getContractsByField = async(field, value, user) => {
  try {
    const userBody = { action: "CONTRACTS_BY_FIELD", field, value};
    let response = await handleContract(user.token, userBody);
    response = await response.json();
    if (response.result) {
      return response.body;
    } else {
      return null;
    }
  } catch (error) {
    debugLog(error);
    return null;
  }
};
